/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_AfterInputs */

const en_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event After`)
};

const fr_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement après`)
};

const de_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach der Veranstaltung`)
};

const it_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dopo`)
};

const ru_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие после`)
};

const es_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento después`)
};

const zh_cn2_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件之后`)
};

const ja_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント後`)
};

const hi_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना के बाद`)
};

const pt_pt2_event_after = /** @type {(inputs: Event_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento após`)
};

/**
* | output |
* | --- |
* | "Event After" |
*
* @param {Event_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_after = /** @type {((inputs?: Event_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_after(inputs)
	if (locale === "de") return de_event_after(inputs)
	if (locale === "it") return it_event_after(inputs)
	if (locale === "ru") return ru_event_after(inputs)
	if (locale === "es") return es_event_after(inputs)
	if (locale === "zh-CN") return zh_cn2_event_after(inputs)
	if (locale === "ja") return ja_event_after(inputs)
	if (locale === "hi") return hi_event_after(inputs)
	if (locale === "pt-PT") return pt_pt2_event_after(inputs)
	return en_event_after(inputs)
});